var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSummaryActivityPlanIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.5C0 1.84531 1.34531 0.5 3 0.5H9.19219C10.0875 0.5 10.9453 0.85625 11.5781 1.48906L13.5891 3.5H21C22.6547 3.5 24 4.84531 24 6.5V18.5C24 20.1547 22.6547 21.5 21 21.5H3C1.34531 21.5 0 20.1547 0 18.5V3.5ZM3 2.75C2.5875 2.75 2.25 3.0875 2.25 3.5V18.5C2.25 18.9125 2.5875 19.25 3 19.25H21C21.4125 19.25 21.75 18.9125 21.75 18.5V6.5C21.75 6.0875 21.4125 5.75 21 5.75H13.4344C12.9375 5.75 12.4594 5.55313 12.1078 5.20156L9.98906 3.07812C9.77813 2.86719 9.49219 2.75 9.19219 2.75H3Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryActivityPlanIcon);
export default __webpack_public_path__ + "static/media/Summary_ActivityPlanIcon.d52babcbd515b4eb27a8d2030abf5865.svg";
export { ForwardRef as ReactComponent };